import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary: "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive: "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline: "text-foreground",
        "traffic-red": "border-transparent bg-[#fde8e6] text-[#c0392b] hover:bg-[#fde8e6]/80",
        "traffic-amber": "border-transparent bg-[#fdf0db] text-[#a06b1a] hover:bg-[#fdf0db]/80",
        "traffic-green": "border-transparent bg-[#e6f4ed] text-[#2d7a4f] hover:bg-[#e6f4ed]/80",
        "review-red": "border-transparent bg-[#fde8e6] text-[#c0392b] hover:bg-[#fde8e6]/80",
        "review-amber": "border-transparent bg-[#fdf0db] text-[#a06b1a] hover:bg-[#fdf0db]/80",
        "review-neutral": "border-transparent bg-gray-100 text-gray-600 hover:bg-gray-100/80",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge };
